<app-de-wrapper>
  <h1 class="heading">Monatsrechnung</h1>

  <div class="text">
    Ihr Einkauf wird auf Ihrer Monatsrechnung von {{ merchantName }} erscheinen.
  </div>

  <hr class="details-divider" />

  <div class="details-container">
    <div class="details-value-entry">Gesamtbetrag</div>
    <div class="details-value-entry">
      {{ state.totalCheckoutValue | value }}
    </div>
  </div>

  <hr class="details-divider" />

  <div class="footer-wrapper">
    <div class="footer-container">
      <zaver-primary-button
        style="margin-top: 48px; margin-bottom: 26px"
        [text]="'Kauf abschließen'"
        [disabled]="navigationInProgress"
        (click)="handleCtaClick()"
      ></zaver-primary-button>

      <ng-container *ngIf="state.totalCheckoutValue">
        <p class="agb-info">
          <button class="modal-btn" (click)="toggleModal()">
            Details anzeigen
          </button>
        </p>
      </ng-container>

      <p class="modal-info">
        Indem Sie Kauf abschließen klicken, stimmen<br />
        Sie den

        <span *ngIf="state?.checkoutCustomizations?.merchantTermsUrlText">
          <a
            [href]="state?.checkoutCustomizations?.merchantTermsUrl"
            target="_blank"
          >
            {{ state?.checkoutCustomizations?.merchantTermsUrlText }}
          </a>
        </span>

        <span *ngIf="!state?.checkoutCustomizations?.merchantTermsUrlText">
          <a
            [href]="state?.checkoutCustomizations?.merchantTermsUrl"
            target="_blank"
          >
            AGB
          </a>
          von {{ state?.checkoutCustomizations?.merchantName }} zu.
        </span>
      </p>
    </div>
  </div>

  <zaver-checkout-modal
    *ngIf="modalActive"
    id="details-modal"
    [buttonText]="'Schließen'"
    [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
    (onClose)="deactivateModal()"
  >
    <app-selector
      #selector
      *ngIf="!!selectorItems"
      [selectorItems]="selectorItems"
      [selectedItem]="selectorItems[0]"
    ></app-selector>
  </zaver-checkout-modal>
</app-de-wrapper>
